<template>
  <div>
    <PersonalView>
    </PersonalView>
  </div>
</template>

<script>
import PersonalView from '../components/PersonalView'

export default {
  components: {
    PersonalView
  }
}
</script>
